import React, { useEffect } from 'react'
import { REGISTER_IN_PERSON_URL } from './URLConstants';
import { Link } from 'react-router-dom';


const RegisterLink = () => {
    useEffect(() => {
        // Redirect to the new link when the component mounts
        window.location.href = 'https://app.cdri.world/icdri2024/icdri-in-person';
    }, []); // Empty dependency array ensures the effect runs only once

    return (
        <div>
            <h1>My Component</h1>
            {/* Additional content if needed */}
        </div>
    );
};

export default RegisterLink;

// export default function RegisterLink() {



//     return (
//         <>
//             <main id="tg-main" className="tg-main tg-haslayout">

//                 <section className="tg-sectionspace tg-haslayout tg-bg" id="tg-about">
//                     <div className="container">
//                         <div className="row">
//                             <div className="tg-aboutus">
//                                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

//                                     <div className="tg-sectionhead tg-textalignleft">
//                                         <div className="tg-sectionheading">

//                                             <h2>ICDRI 2024 In-Person Registration</h2>
//                                         </div>
//                                         <div className="tg-description">
//                                             <p>
//                                                 The International Conference on Disaster Resilient Infrastructure 2023 will follow a hybrid format as in the last edition and will be organized on 4-5 April 2023 in New Delhi, India. The theme of this year’s conference is ‘Delivering Resilient and Inclusive Infrastructure: Pathways for Risk Informed Systems, Practices and Investments’.</p>
//                                             <p><br /></p>
//                                             <p>
//                                                 ICDRI 2023 will bring to fore demonstrated practices and solutions, delving into systems, practices, and finances, that enable provisioning of resilient infrastructure to people and economies across different geographies, climate typologies and infrastructure sectors.

//                                             </p>
//                                             <p><br /></p>
//                                             <p>
//                                                 <Link to={REGISTER_IN_PERSON_URL} className="tg-btn nofade" target='_blank'>Click here to enter information</Link></p>

//                                         </div>

//                                     </div>

//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 </section>

//             </main >
//         </>
//     )
// }
